module.exports = __webpack_public_path__ + "static/media/Cara.556d29fd.jpg";